export default __webpack_public_path__ + "static/media/Header_logo.f83ec3b3.png";